import { ingDeskService } from "../../services/IngDesk/ingDeskService";

export function addContactInIngDesk(contactData) {
  return async (dispatch, getState) => {
    const { serviceurl, informationusers } = getState();

    // const hasIngDesk =
    //   Array.isArray(serviceurl) &&
    //   serviceurl.some(
    //     (service) =>
    //       Boolean(service.typeofcrm) &&
    //       typeof service.typeofcrm === "string" &&
    //       service.typeofcrm.toLowerCase() === "ingdesk"
    //   );
    // if (!hasIngDesk) return;
    const baseUrl = informationusers.backendingdesk;
    const hasBaseUrl = Boolean(baseUrl);
    if (!hasBaseUrl) return;
    const loginUser = informationusers.username;
    const hasLoginUser = Boolean(loginUser);
    if (!hasLoginUser) return;

    const token = await ingDeskService.getIngDeskToken(baseUrl, loginUser);
    const hasToken = Boolean(token);
    if (!hasToken) return;
    // aqui vem as rotas de inserir/editar o contato no ingDesk
    await ingDeskService.insertOrUpdateContact(contactData, baseUrl, token);
  };
}
